import { useState, useEffect } from "react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";
import axios from "axios";
import { API_URL } from "@/utils/apiConfig";
import useEstafetaLang from "@/hooks/useEstafetaLang";
import useEstafetaPWA from "@/hooks/useEstafetaPWA";
import EstafetaLogin from "@/components/estafeta/EstafetaLogin";
import EstafetaDashboard from "@/components/estafeta/EstafetaDashboard";

const API = API_URL;

export default function EstafetaApp() {
  const [deliverer, setDeliverer] = useState(null);
  const [token, setToken] = useState(null);
  const [checking, setChecking] = useState(true);
  const { lang, setLang, t } = useEstafetaLang();
  const { installPrompt, handleInstall } = useEstafetaPWA({ token, t });

  useEffect(() => {
    console.log("[ESTAFETA_BUILD]", "force-debug-v2");
    console.log("[ESTAFETA_APP_BOOTSTRAP] mounted api=", API);
    // Pre-fill token from deep link URL (e.g. ?token=xxx from WA access message)
    const urlParams = new URLSearchParams(window.location.search);
    const urlToken = urlParams.get("token");
    if (urlToken) {
      localStorage.setItem("estafeta_token", urlToken);
      window.history.replaceState({}, "", window.location.pathname);
    }
    const saved = localStorage.getItem("estafeta_token");
    console.log("[ESTAFETA_TOKEN_CHECK]", saved ? `exists len=${saved.length} prefix=${saved.slice(0, 8)}` : "null — vai mostrar login");
    if (saved) {
      const authUrl = `${API}/api/v1/deliverers/auth/token?token=${encodeURIComponent(saved)}`;
      console.log("[ESTAFETA_AUTH_START] url=", authUrl);
      axios.post(authUrl)
        .then(res => {
          const authPayload = res.data?.data || res.data;
          console.log("[ESTAFETA_AUTH_SUCCESS] deliverer_id=", authPayload.deliverer?.id);
          setDeliverer(authPayload.deliverer);
          setToken(saved);
        })
        .catch((err) => {
          console.error("[ESTAFETA_AUTH_FAILED] status=", err.response?.status ?? "network", "msg=", err.message, "url=", authUrl);
          localStorage.removeItem("estafeta_token");
        })
        .finally(() => setChecking(false));
    } else {
      setChecking(false);
    }
  }, []);

  if (checking) {
    return (
      <div className="min-h-screen bg-emerald-700 flex items-center justify-center">
        <Loader2 className="w-8 h-8 text-white animate-spin" />
      </div>
    );
  }

  if (!deliverer || !token) {
    return <EstafetaLogin onLogin={(d, t2) => { setDeliverer(d); setToken(t2); }} lang={lang} setLang={setLang} t={t} />;
  }

  return (
    <>
      <EstafetaDashboard
        deliverer={deliverer}
        token={token}
        onLogout={() => { setDeliverer(null); setToken(null); }}
        lang={lang}
        setLang={setLang}
        t={t}
      />
      {installPrompt && (
        <div className="fixed bottom-4 left-4 right-4 bg-emerald-700 text-white rounded-xl p-4 flex items-center justify-between shadow-xl z-50" data-testid="install-prompt">
          <div>
            <p className="font-bold text-sm">{t("installApp")}</p>
            <p className="text-emerald-200 text-xs">{t("installDesc")}</p>
          </div>
          <Button onClick={handleInstall} className="bg-white text-emerald-700 font-bold hover:bg-emerald-50" data-testid="install-btn">
            {t("install")}
          </Button>
        </div>
      )}
    </>
  );
}
